// In-house adaptation of Print.js (crabbly)
const FRAME_ID = "printer-frame";

function cleanUp(params) {
  // Run onPrintDialogClose callback
  let event = "focus";

  const handler = () => {
    // Make sure the event only happens once.
    window.removeEventListener(event, handler);

    params.onPrintDialogClose();

    // Remove iframe from the DOM
    const iframe = document.getElementById(FRAME_ID);

    if (iframe) {
      iframe.remove();
    }

    if (params && params._objectUrl) {
      try {
        window.URL.revokeObjectURL(params._objectUrl);
      } catch (_) {}
      params._objectUrl = null;
    }
  };

  window.addEventListener(event, handler);
}

function performPrint(iframeElement, params) {
  try {
    iframeElement.focus();

    const attemptPrint = () => {
      try {
        iframeElement.contentWindow.print();
      } catch (error) {
        params.onError(error);
      }
    };

    setTimeout(function () {
      params.onPrintWindowTriggered();
      attemptPrint();
      setTimeout(function () {
        attemptPrint();
      }, 300);
    }, 700);
  } catch (error) {
    params.onError(error);
  } finally {
    cleanUp(params);
  }
}

export function printPdfFile(params) {
  //
  params.onLoadingStart();

  // To prevent duplication and issues, remove any used printFrame from the DOM
  const usedFrame = document.getElementById(FRAME_ID);
  if (usedFrame) {
    usedFrame.parentNode.removeChild(usedFrame);
  }

  // Create a new iframe for the print job
  const printFrame = document.createElement("iframe");
  printFrame.setAttribute(
    "style",
    "visibility: hidden; height: 0; width: 0; position: absolute; border: 0"
  );
  printFrame.setAttribute("id", FRAME_ID);

  // print pdf
  if (params.printable.indexOf(",") !== -1) {
    //If pdf base64 start with `data:application/pdf;base64,`,Excute the atob function will throw an error.So we get the content after `,`
    params.printable = params.printable.split(",")[1];
  }
  const bytesArray = Uint8Array.from(atob(params.printable), (c) =>
    c.charCodeAt(0)
  );

  let localPdf = new window.Blob([bytesArray], { type: "application/pdf" });

  // Store createObjectURL so we can revoke later
  let objectUrl = window.URL.createObjectURL(localPdf);
  params._objectUrl = objectUrl;
  printFrame.setAttribute("src", objectUrl);

  // Append iframe element to document body
  document.getElementsByTagName("body")[0].appendChild(printFrame);

  // Get iframe element
  const iframeElement = document.getElementById(FRAME_ID);

  if (iframeElement) {
    // Wait for iframe to load all content
    let loaded = false;
    iframeElement.onload = () => {
      loaded = true;
      performPrint(iframeElement, params);
      return;
    };

    setTimeout(function () {
      if (!loaded) {
        try {
          params.onError("iframe failed to load PDF for printing");
        } catch (_) {}
        cleanUp(params);
      }
    }, 2500);
  } else {
    params.onError("Iframe not found (couldn't append to the body?)");
  }
}
